import React, { useEffect, useState, useContext } from 'react'
import { getDoc, doc, getDocs, collection, query, where, limit, orderBy, updateDoc, onSnapshot } from "firebase/firestore"

import { db, auth, requestNotificationToken } from '../firebase.js';
import SignUpCompletionForm from '../component/SignUpCompletionFormComponents/SignUpCompletionForm.js';

import UserContext from './UserContext.js';
import PhoneVerification from '../component/PhoneVerification/PhoneVerification.js';

export function CheckUserInDatabase(props) {

    const userCtx = useContext(UserContext);
    const [complete, setComplete] = useState(false);


    //this is to check the first time if there is unread questions    
    useEffect(() => {
        console.log("hone: ", userCtx.authClaims)
        const q = query(collection(db, 'questions'), where("sender_id", "==", auth.currentUser.uid), where("question_status", "in", ['read', 'done']), orderBy('createdAt', 'desc'), limit(40))

        const getusers = async () => {
            const data = await getDocs(q);
            let nmb = 0;
            // eslint-disable-next-line array-callback-return
            data.docs.map((docu) => { if (docu.data().question_status === 'done' && !docu.data().read) nmb++; })
            userCtx.setUnreadAnswers(nmb);
        }

        getusers();
    }, [])


    const [infoSetupForm, setInfoSetupForm] = useState(false)
    const docRef = doc(db, "users", auth.currentUser.uid);
    useEffect(() => {

        onSnapshot(docRef, (snapshot) => {
            console.log('user data fetched')
            const docData = snapshot.data();
            const now = new Date().getTime();//now date

            if (snapshot.exists() && docData.remembersPeopleBy) {

                // To calculate the no. of days between two dates
                let daysLeft = Math.floor((docData.expiry_date.toDate().getTime() - now) / (1000 * 3600 * 24));

                userCtx.setUserData({ ...docData, daysLeft });
                if (docData.expiry_date.toDate().getTime() < now) {//not
                    console.log(" account is not subscribed");
                    userCtx.setIsSubscribed(false);
                }
                else {
                    console.log(" account is subscribed")//is
                    userCtx.setIsSubscribed(true);
                }

                if ("serviceWorker" in navigator && "PushManager" in window) {
                    //console.log("This browser supports notifications and service workers")
                    requestNotificationToken().then((currentToken) => { HandleTokenUpdate(docRef, docData, currentToken) })
                }


            }


            else {
                console.log("account  info are not available!");
                setInfoSetupForm(true);
                userCtx.setIsSettingInfo(true);
            }
        })


    }, [])


    async function HandleTokenUpdate2(docRef, currentUserData, currentToken) {
        if (currentToken && currentUserData) {
          const tokenArray = currentUserData.notification_tokens || [];
      
          if (!tokenArray.includes(currentToken)) {
            await updateDoc(docRef, {
           //   notification_tokens: firebase.firestore.FieldValue.arrayUnion(currentToken)
            })
              .then(() => console.log('Token array updated with', currentToken))
              .catch((e) => console.error(e));
          } else {
            console.log('All tokens are up to date');
          }
        }
      }
      
    async function HandleTokenUpdate(docRef, currentUserData, currentToken) {
        if (currentToken) {
            //   console.log('current token: ', currentToken);

            if (currentUserData.notification_tokens) {

                if (!currentUserData.notification_tokens.includes(currentToken)) {
                    await updateDoc(docRef, {
                        notification_tokens: [currentToken,
                            ...currentUserData.notification_tokens
                        ]
                    }).then(() => console.log('token array updated with', currentToken))
                        .catch((e) => console.error(e));
                }
                else console.log("all tokens ar up to date")
            }
            else {
                await updateDoc(docRef, {
                    notification_tokens: [currentToken,]
                }).then(() => console.log('token array created with', currentToken))
                    .catch((e) => console.error(e));
            }

        }

    }







    return (
        <>
            {infoSetupForm &&
                <SignUpCompletionForm onClick={() => {
                    userCtx.setIsSettingInfo(false);
                    setInfoSetupForm(false);
                    setComplete(true);
                }} />
            }

            {(complete
                && userCtx.user !== null
                && !auth.currentUser.phoneNumber
            )
                && <PhoneVerification />}
        </>
    )
}

export default CheckUserInDatabase
